<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight - 4"
      :toolbar="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="scmCode"
    >
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.scmStatus === 'Y'
              ? 'success'
              : row.scmStatus === 'P'
              ? 'primary'
              : 'danger'
          "
        >
          {{ row.scmStatusName }}
        </el-tag>
      </template>
      <template v-slot:scmName="{ row }">
        <div>No：{{ row.scmNo }}</div>
        <div>
          <el-link
            :underline="false"
            type="primary"
            @click="viewScmDetail(row.scmCode)"
          >
            {{ row.scmName }}
          </el-link>
        </div>
        <div>CC：{{ row.businessLicense ? row.businessLicense : '--' }}</div>
      </template>
      <template v-slot:scmMode="{ row }">
        <div>
          {{ row.scmTypeName }}
        </div>
        <div>
          Category：{{ row.scmCategoryName ? row.scmCategoryName : '--' }}
        </div>
        <div class="d-flex">
          <div class="mr-2">
            <el-tag
              size="mini"
              :type="row.isCooperation === 'Y' ? 'success' : 'info'"
            >
              {{ row.isCooperationName }}
            </el-tag>
          </div>
          <div class="mr-2">
            <el-tag
              size="mini"
              :type="
                row.scmMode === 'C'
                  ? 'success'
                  : row.scmMode === 'B'
                  ? ''
                  : 'info'
              "
            >
              {{ row.scmModeName ? row.scmModeName : 'Not set' }}
            </el-tag>
          </div>
        </div>
      </template>
      <template v-slot:scmAddressInfo="{ row }">
        <div>
          {{ row.provinceName }} {{ row.cityName }} {{ row.districtName }}
        </div>
        <div>
          {{ row.scmAddress }}
        </div>
      </template>
      <template v-slot:bankInfo="{ row }">
        <div>
          {{ row.bankName ? row.bankName : '--' }}
        </div>
        <div>
          {{ row.bankAccountName ? row.bankAccountName : '--' }}
        </div>
        <div>
          {{ row.bankAccountNo ? row.bankAccountNo : '--' }}
        </div>
        <div v-if="row.bankCount > 1">
          <el-tag size="mini">
            {{ row.bankCount }}
            {{ $l('INDEX.tips_bank_accounts') || '个银行账号' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <b-button variant="light"><i class="el-icon-more"></i></b-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="'view:' + row.scmCode"
                >{{ $l('tips_view_info') || '查看详细信息' }}</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-edit"
                :disabled="row.scmStatus === 'P'"
                :command="'editSupplier:' + row.scmCode"
                >{{
                  $l('tips_view_info_Modify') || '修改供应商信息'
                }}</el-dropdown-item
              >

              <el-dropdown-item
                icon="el-icon-postcard"
                divided
                :command="'addContact:' + row.scmCode"
                >{{ $l('tips_add_contact') || '新增名片' }}</el-dropdown-item
              >
              <!-- :disabled="data.item.isCooperation === 'Y'" -->
              <el-dropdown-item
                icon="el-icon-check"
                :disabled="row.scmMode === 'C' || row.scmStatus === 'P'"
                :command="'regularApply:' + row.scmCode"
                >{{ $l('tips_regularApply') || '申请转正' }}</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-edit-outline"
                :disabled="
                  row.scmMode == 'A' ||
                    !(row.modifyJson == '' || row.modifyJson == null)
                "
                :command="'informationChange:' + row.scmCode"
                >{{
                  $l('form_supplier_information_change_application') ||
                    '供应商信息变更申请'
                }}</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-map-location"
                :command="'addVisit:' + row.scmCode"
                >{{ $l('tips_add_visit') || '新增拜访记录' }}</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-picture-outline"
                :command="'addImage:' + row.scmCode"
                >{{ $l('tips_add_file') || '上传文件' }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center" class="mt-5">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      ref="addContactDialog"
      @opened="dialogOpened"
      :title="$l('tips_add_contact') || '新增名片'"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="addNewCancel"
      :close-on-click-modal="false"
      width="1000px"
    >
      <add-contact
        ref="contactsDetail"
        @success="addNewSuccess"
        @addNewCancel="addNewCancel"
      ></add-contact>
    </el-dialog>
    <el-dialog
      ref="supplierImageForm"
      @opened="supplierImageDialogOpened"
      :title="$l('tips_add_file') || '文件上传'"
      :visible.sync="formOption.supplierImageFormVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <upload-image
        ref="uploadImage"
        @supplierImageSuccess="supplierImageSuccess"
      ></upload-image>
    </el-dialog>

    <el-dialog
      :title="
        $l('form_supplier_information_change_application') ||
          '供应商信息变更申请'
      "
      width="1100px"
      v-if="formOption.informationChangeVisible"
      :close-on-click-modal="false"
      show-close
      :visible.sync="formOption.informationChangeVisible"
      top="10vh"
      destroy-on-close
      append-to-body
    >
      <informationChange
        @close="closeInformationChangeVisible()"
        :scmCode="formData.scmCode"
      />
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  components: {
    AddContact: () => import('../contact/edit'),
    uploadImage: () => import('../scmImages/uploadImage'),
    informationChange: () => import('../informationChange/index.vue'),
  },
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
        custom: true,
      },
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        supplierImageFormVisible: false,
        informationChangeVisible: false,
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          headerAlign: 'center',
          align: 'center',
          type: 'seq',
        },
        {
          field: 'scmName',
          headerAlign: 'left',
          align: 'left',
          minWidth: 300,
          title: this.$l('table_scm_label_scmName') || '供应商',
          slots: {
            default: 'scmName',
          },
        },
        {
          field: 'scmMode',
          headerAlign: 'left',
          align: 'left',
          minWidth: 250,
          showHeaderOverflow: 'title',
          title: this.$l('form_label_supply_chain_model') || '合作模式',
          slots: { default: 'scmMode' },
        },
        {
          field: 'status',
          minWidth: 100,
          title: this.$l('table_label_status') || '状态',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          align: 'center',
          slots: { default: 'status' },
        },
        {
          field: 'scmAddressInfo',
          minWidth: 300,
          title: this.$l('table_label_supply_detailed_address') || '详细地址',
          headerAlign: 'left',
          align: 'left',
          slots: { default: 'scmAddressInfo' },
        },
        {
          field: 'bankInfo',
          minWidth: 300,
          title: this.$l('table_lable_bank') || '银行账户',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          align: 'left',
          slots: { default: 'bankInfo' },
        },
        {
          field: 'createInfo',
          headerAlign: 'left',
          align: 'left',
          width: 170,
          title: this.$l('INDEX.creator') || '创建人',
          showHeaderOverflow: 'title',
          slots: { default: 'createInfo' },
        },
        {
          field: 'modifyInfo',
          headerAlign: 'left',
          align: 'left',
          width: 170,
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          showHeaderOverflow: 'title',
          slots: { default: 'modifyInfo' },
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
      ],
      formData: {},
      curScmCode: '',
    }
  },
  activated() {
    this.reload()
  },
  methods: {
    viewScmDetail(val) {
      this.$router.push({
        name: 'resourceManagement-scmInfoDetail',
        params: {
          pageType: 'view',
          scmCode: val,
        },
      })
    },
    editSupplier(val) {
      let params = {
        pageType: 'edit',
        scmCode: val,
        diversity: 'ordinary',
      }
      // 跳转页面
      this.$router.push({
        name: 'resourceManagement-scmInfoTemp',
        params: params,
      })
    },
    applySupplier(val) {
      let params = {
        pageType: 'apply',
        scmCode: val,
        diversity: 'ordinary',
      }
      // 跳转页面
      this.$router.push({
        name: 'resourceManagement-scmInfoTemp',
        params: params,
      })
    },
    handleCommand(command) {
      let type = (command || '').split(':')[0]
      let scmCode = (command || '').split(':')[1]

      if (type === 'view') {
        this.viewScmDetail(scmCode)
      } else if (type === 'editSupplier') {
        this.editSupplier(scmCode)
      } else if (type === 'addContact') {
        this.addNewContact(scmCode)
      } else if (type === 'addVisit') {
        this.addScmVisit('add', 'new', scmCode)
      } else if (type === 'addImage') {
        this.supplierImage(scmCode)
      } else if (type === 'regularApply') {
        this.applySupplier(scmCode)
      } else if (type === 'informationChange') {
        this.informationChange(scmCode)
      }
    },
    addNewContact(val) {
      this.formData = {
        type: 'add',
        scmCode: val,
        contactNameCardUrl1: '',
      }
      this.formOption.dialogFormVisible = true
    },
    informationChange(val) {
      this.formData = {
        scmCode: val,
      }
      this.formOption.informationChangeVisible = true
    },
    dialogOpened() {
      this.$refs.contactsDetail.init(this.formData)
    },
    addNewSuccess() {
      this.formOption.dialogFormVisible = false
      this.$emit('reload')
    },
    reload() {
      this.$emit('reload')
    },
    addNewCancel() {
      this.formOption.dialogFormVisible = false
    },
    addScmVisit(type, val, scmCode) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-edit',
        params: {
          pageType: type,
          visitCode: val,
          scmCode: scmCode,
        },
      })
    },
    supplierImage(scmCode) {
      this.curScmCode = scmCode
      this.formOption.supplierImageFormVisible = true
    },
    supplierImageDialogOpened() {
      this.$refs.uploadImage.init(this.curScmCode)
    },
    supplierImageSuccess() {
      this.formOption.supplierImageFormVisible = false
    },
    closeInformationChangeVisible() {
      this.formOption.informationChangeVisible = false
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped>
.table-text {
  color: #6c757d;
  font-size: 14.4px;
}
</style>
